module.exports = __webpack_public_path__ + "static/img/HR.f823580c.svg";